import React, { useState } from 'react';
import { GraduationCap } from 'lucide-react';
import './Training.css';
import logoblanco from '../images/logoblanco.png';
import logo from '../images/logonegro.png';

import formacion1 from '../images/formacion/formacion1.JPG';
import formacion2 from '../images/formacion/formacion2.JPG';
import formacion3 from '../images/formacion/formacion3.JPG';
import formacion4 from '../images/formacion/formacion4.JPG';
import formacion5 from '../images/formacion/formacion5.JPG';
import formacion6 from '../images/formacion/formacion6.jpeg';

const Training = () => {
    const [hover, setHover] = useState(false);

    const trainingImages = [
        { src: formacion1, alt: 'Formación 1' },
        { src: formacion2, alt: 'Formación 2' },
        { src: formacion3, alt: 'Formación 3' },
        { src: formacion4, alt: 'Formación 4' },
        { src: formacion5, alt: 'Formación 5' },
        { src: formacion6, alt: 'Formación 6' }
    ];

    return (
        <div className="training-page">
            <div className="training-header">
                <h1>Formación Continua</h1>
                <p>Comprometidos con la excelencia y la actualización profesional</p>
            </div>

            <div className="container">
                <section className="training-intro">
                    <div className="intro-icon">
                        <GraduationCap size={48} />
                    </div>
                    <p>
                        En la práctica de cualquier rama en salud, y por supuesto en fisioterapia, consideramos
                        fundamental que se base en la evidencia científica. Para ello es necesario actualizarnos
                        y formarnos constantemente como profesionales con el fin de ofrecer el mejor tratamiento y
                        abordaje a nuestros pacientes.
                    </p>
                </section>

                <section className="scienze-section">
                    <div className="scienze-content">
                        <h2>Scienze Formación</h2>
                        <p>
                            En 2016, de la mano de Javier Vidal, nació en Zaragoza
                            <span className="highlight"> Scienze Formación</span>,
                            generando un nuevo espacio en el que aprender, desaprender y reaprender, donde los fisioterapeutas
                            y otros compañeros que trabajan en Salud se convierten en mejores profesionales.
                        </p>
                        <p>
                            Fisioterapia Pedrola se esfuerza día a día y mantiene sus conocimientos clínicos actualizados haciendo que
                            vosotros recibáis tratamientos que realmente han sido contrastados con evidencias empíricas.
                        </p>
                    </div>
                </section>

                <section className="training-gallery">
                    <h2>Nuestras Formaciones</h2>
                    <div className="gallery-grid">
                        {trainingImages.map((image, index) => (
                            <div key={index} className="gallery-item">
                                <img
                                    src={image.src}
                                    alt={image.alt}
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                </section>

                <section className="scienze-link-section">
                    <div className="scienze-card">
                        <h3>Visita Scienze Formación</h3>
                        <a
                            href='https://scienzeformacion.es'
                            target="_blank"
                            rel="noopener noreferrer"
                            className="logo-link"
                            onMouseEnter={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                        >
                            <img
                                src={hover ? logo : logoblanco}
                                alt="Scienze Formación"
                                className="scienze-logo"
                            />
                        </a>

                        <div className="scienze-links">
                            <a href='https://www.scienzeformacion.es/#cursos' target="_blank" rel="noopener noreferrer">
                                Cursos
                            </a>
                            <a href='https://www.scienzeformacion.es/videos' target="_blank" rel="noopener noreferrer">
                                Videos
                            </a>
                            <a href='https://www.scienzeformacion.es/#docentes' target="_blank" rel="noopener noreferrer">
                                Docentes
                            </a>
                            <a href='https://www.scienzeformacion.es/blog' target="_blank" rel="noopener noreferrer">
                                Blog
                            </a>
                            <a href='https://www.scienzeformacion.es/#contacto' target="_blank" rel="noopener noreferrer">
                                Contacto
                            </a>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Training;
